/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MessageLanguageOptions } from '../../models/message-language-options';

export interface GetMessageLanguages$Params {
}

export function getMessageLanguages(http: HttpClient, rootUrl: string, params?: GetMessageLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<MessageLanguageOptions>> {
  const rb = new RequestBuilder(rootUrl, getMessageLanguages.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MessageLanguageOptions>;
    })
  );
}

getMessageLanguages.PATH = '/messages/languages';
